import {
    EXPORT_EMPLOYEES_REIMBURSEMENT_REQUEST,
    EXPORT_EMPLOYEES_REIMBURSEMENT_SUCCESS,
    EXPORT_EMPLOYEES_REIMBURSEMENT_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const exportEmployeesReimbursementReducer = (state = initialState, action) => {
    switch (action.type) {
        case EXPORT_EMPLOYEES_REIMBURSEMENT_REQUEST:
            return {
                error: "",
                loading: true,
                data: [],
            };

        case EXPORT_EMPLOYEES_REIMBURSEMENT_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case EXPORT_EMPLOYEES_REIMBURSEMENT_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
}

export default exportEmployeesReimbursementReducer;
